import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { CursorIcon, WhiteBoardLockIcon } from '@sketchnote/icons';
import * as React from 'react';
import {
  StatusBar,
  StyledCenterWrap,
  StyledPrimaryTools,
  StyledToolsPanelContainer,
  TDSnapshot,
  ToolButton,
  useTldrawApp,
} from 'sn-wb-tldraw';

import { StyleMenu } from '../TopPanel/StyleMenu';
import { ActionButton } from './ActionButton';
import { BackToContent } from './BackToContent';
import { DeleteButton } from './DeleteButton';
import { PrimaryTools } from './PrimaryTools';

const activeToolSelector = (s: TDSnapshot) => s.appState.activeTool;
const isDebugModeSelector = (s: TDSnapshot) => s.settings.isDebugMode;

interface ToolsPanelProps {
  onBlur?: React.FocusEventHandler;
}

export const ToolsPanel = React.memo(function ToolsPanel({ onBlur }: ToolsPanelProps): JSX.Element {
  const app = useTldrawApp();
  const isDebugMode = app.useStore(isDebugModeSelector);
  const activeTool = app.useStore(activeToolSelector);

  const selectSelectTool = React.useCallback(() => {
    app.selectTool('select');
  }, [app]);

  const selectMoveTool = React.useCallback(() => {
    app.selectTool('move');
  }, [app]);

  return (
    <StyledToolsPanelContainer onBlur={onBlur}>
      <StyledCenterWrap id="TD-Tools">{/* <BackToContent /> */}</StyledCenterWrap>
      <StyledPrimaryTools>
        <div
          className="flex flex-row mb-8 my-11 bg-white justify-center items-center relative hover:bg-gray-199 w-92 h-38 smallScreen:w-64 smallScreen:h-34 "
          style={{
            boxShadow: '0px 4px 4px rgba(135, 138, 146, 0.15)',
            border: '1px solid #E2E4E9',
            borderRadius: '6px',
            cursor: 'pointer',
          }}
        >
          <div
            className={`flex justify-center w-1/2 items-center z-100`}
            onClick={selectSelectTool}
          >
            <div className="cursor-pointer" id="TD-PrimaryTools-CursorArrow">
              <CursorIcon
                fill={`${activeTool === 'select' ? '#FFFFFF' : '#878A92'}`}
                wrapperClass={`${
                  activeTool === 'select' ? 'transform scale-120' : 'text-gray-500'
                }`}
              />
            </div>
          </div>
          <div onClick={selectMoveTool} className="flex justify-center items-center  w-1/2 z-100">
            <WhiteBoardLockIcon
              fill={`${activeTool === 'move' ? '#FFFFFF' : '#878A92'}`}
              wrapperClass={`${activeTool === 'move' ? 'transform scale-120' : 'text-gray-500'}`}
            />
          </div>
          <div
            className={`w-46 h-36 smallScreen:w-32 smallScreen:h-34 rounded-md absolute transition-all duration-150 ease-in-out   ${
              activeTool === 'select' ? ' top-0 left-0 bg-primary-500' : ''
            } ${activeTool === 'move' ? ' top-0 left-47 smallScreen:left-32 bg-primary-500' : ''}`}
          ></div>
        </div>
        <PrimaryTools />
        {/* <div
          className="bg-gray-160 mt-8 pl-4"
          style={{
            boxShadow: '0px 0px 16px -1px rgba(0, 0, 0, 0.05)',
          }}
        >
          <DeleteButton />
        </div> */}
      </StyledPrimaryTools>

      {/* {isDebugMode && (
        <StyledStatusWrap>
          <StatusBar />
        </StyledStatusWrap>
      )} */}
    </StyledToolsPanelContainer>
  );
});
